<template>
  <div id="app">
    <router-view /> 
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style scope>
#app{
  height: 100%;
  background-image: linear-gradient(rgb(214, 230, 255), rgb(254, 254, 255));
}
.el-dialog {
  align-items: center;
  border-radius: 10px;
  width: 600px;
  background-image: linear-gradient(#d7e6ff, #f0f0f1) !important;
}
.el-dialog__body {
  align-items: center;
  padding-top: 10px !important 
}

.el-dialog__title {
  font-family: SourceHanSansCN-Normal;
  margin-top: 25px;
  margin-bottom: 25px;
}
</style>
